import { useTranslation } from "react-i18next";
import "../styles/about.css";

function About() {
  const { t } = useTranslation();

  return (
    <section id="about" className="about-section">
      <h3 className="about-title">{t("about.title")}</h3>
      <p className="about-description">{t("about.description")}</p>
    </section>
  );
}

export default About;
